import React, { useContext, useMemo, useState, useEffect } from 'react';
import Link from 'next/link';
import { isEmpty, sample } from 'lodash';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { deviceType } from 'react-device-detect';
import {
  Box,
  Flex,
  Text,
  Image,
  Divider,
  Button,
  Input,
  Spinner,
  IconButton,
  SimpleGrid,
  useDisclosure,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  useColorMode,
} from '@chakra-ui/react';
import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react';
import { priceStx, price as priceUsd, shareOnFacebook, shareOnTwitter } from 'utils/utility';
import { getStxAddress, truncate } from 'lib/utility';
import { AuthContext } from 'contexts/auth/auth.context';
import notification from 'components/Notifications';
import { authenticate, purchaseNFTLayer, userSession } from 'utils/stacks';
import { API } from 'config/api';
import { useRouter } from 'next/router';
import { FaFacebook, FaTwitter } from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';
import { BsFillShareFill } from 'react-icons/bs';
import Pagination from 'components/Pagination';
import axios from 'axios';
import { useAuthDispatch } from 'contexts/0Auth';
import { bgColor } from 'config/data';

const Step1 = ({
  setStep,
  data = {},
  access_token,
  currentUser,
  quantity,
  onUpdate,
  updated,
  loading,
  intentUsd,
  intentStx,
  collection,
  meta,
  onPaginate,
  transactions,
  isLoading,
}) => {
  // console.log('data', data);
  // console.log('meta', meta);
  const [image, setImage] = useState(null);
  const [device, setDevice] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  // console.log('intentUsd', intentUsd);
  // console.log('intentStx', intentStx);
  const { id, price, user } = data;
  const router = useRouter();
  const { authDispatch } = useContext(AuthContext);
  const { goToOauth } = useAuthDispatch();

  const pathname = router.asPath;

  const onGoToAuth = async () => {
    await axios.post('/api/current', { pathname });
    goToOauth();
  };
  const { colorMode } = useColorMode();

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      setDevice(deviceType);
    }
    return () => (isSubscribed = false);
  }, []);

  const onPayUsd = async () => {
    if (currentUser?.isLoggedIn) {
      setStep(2);
    } else {
      // authDispatch({ type: 'SHOW_MODAL' });
      onGoToAuth();
    }
  };

  const debouncedSave = useMemo(
    () =>
      debounce((val) => {
        onUpdate(Number(val));
        // router.query.quantity = val;
        // router.replace(router);
      }, 500),
    []
  );

  const onOpenModal = (image) => {
    setImage(image);
    onOpen(true);
  };

  const onPayStx = () => {
    if (currentUser?.isLoggedIn) {
      // Intent STX
      const config = { headers: { Authorization: `Bearer ${access_token}` } };
      API.post(`nft/mintPool/${id}/intent`, { method: 'stx', quantity }, config)
        .then((res) => {
          const intent = res.data.data.stx_transfer;
          // console.log('intent', intent);
          const amount = intent.amount; // intent.amount
          const memo = intent.memo; // intent.memo
          if (userSession.isUserSignedIn()) {
            const p = new Promise((resolve, reject) => purchaseNFTLayer(amount, memo, resolve));
            p.then((txId) => {
              const dataPurchase = {
                intent: intent?.intent_token,
                transaction_id: txId,
                method: 'stx',
              };
              API.post(`/nft/mintPool/${id}/purchase`, dataPurchase, config)
                .then(() => setStep(3))
                .catch((err) => notification('error', `❌${err.response.data.message}`));
            });
          } else {
            authenticate(() => {
              const p = new Promise((resolve, reject) => purchaseNFTLayer(amount, memo, resolve));
              p.then((txId) => {
                const dataPurchase = {
                  intent: intent?.intent_token,
                  transaction_id: txId,
                  method: 'stx',
                };
                API.post(`/nft/mintPool/${id}/purchase`, dataPurchase, config)
                  .then(() => setStep(3))
                  .catch((err) => notification('error', `❌${err.response.data.message}`));
              });
            });
          }
        })
        .catch((err) => notification('error', `❌${err.response.data.message}`));
    } else {
      // authDispatch({ type: 'SHOW_MODAL' });
      onGoToAuth();
    }
  };

  const onPayStxUpdated = () => {
    console.log('aqui');
    if (currentUser?.isLoggedIn) {
      const intent = intentStx;
      console.log('intent', intent);
      const amount = intent.amount; // intent.amount
      const memo = intent.memo; // intent.memo
      if (userSession.isUserSignedIn()) {
        const p = new Promise((resolve, reject) => purchaseNFTLayer(amount, memo, resolve));
        p.then((txId) => {
          const dataPurchase = {
            intent: intent?.intent_token,
            transaction_id: txId,
            method: 'stx',
          };
          API.post(`/nft/mintPool/${id}/purchase`, dataPurchase, config)
            .then(() => setStep(3))
            .catch((err) => notification('error', `❌${err.response.data.message}`));
        });
      } else {
        authenticate(() => {
          const p = new Promise((resolve, reject) => purchaseNFTLayer(amount, memo, resolve));
          p.then((txId) => {
            const dataPurchase = {
              intent: intent?.intent_token,
              transaction_id: txId,
              method: 'stx',
            };
            API.post(`/nft/mintPool/${id}/purchase`, dataPurchase, config)
              .then(() => setStep(3))
              .catch((err) => notification('error', `❌${err.response.data.message}`));
          });
        });
      }
    } else {
      // authDispatch({ type: 'SHOW_MODAL' });
      onGoToAuth();
    }
  };

  const randomNft = sample(collection);

  const url =
    process.env.NEXT_PUBLIC_ENV === 'staging'
      ? `https://staging.heylayer.com/mintpool/${id}`
      : `https://heylayer.com/mintpool/${id}`;

  return (
    <Flex mt="40px" flexDirection={{ base: 'column', md: 'row' }}>
      <Modal size="2xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent p="20px 5px">
          {/* <ModalCloseButton /> */}
          <ModalBody>
            <Image src={image} alt="" />
          </ModalBody>
        </ModalContent>
      </Modal>

      {device === 'mobile' && (
        <Box w={{ base: '100%', md: '400px' }} m="0 auto" id="card">
          <Flex flexDirection="column" pos="relative" mb="20px" justifyContent="center" alignItems="center">
            <Flex flexDir="column" zIndex={10} justifyContent="center" alignItems="center">
              <Box borderRadius={8}>
                {randomNft ? (
                  <Box pos="relative" zIndex={1}>
                    <Image
                      objectFit="contain"
                      src={randomNft?.file?.thumbnail_http_url}
                      alt=""
                      borderRadius="8px 8px 0 0"
                    />
                  </Box>
                ) : (
                  <Box pos="relative" zIndex={1}>
                    <Image pos="absolute" top="41%" left="40%" src="/images/wrc-logo-card.png" alt="" />
                    <Image objectFit="contain" src="/images/card_example_2.png" alt="" />
                  </Box>
                )}

                <Flex
                  pos="relative"
                  flexDirection="column"
                  id="title"
                  bg="#fff"
                  borderRadius={8}
                  borderWidth={1}
                  p="10px 20px 30px"
                  mt="-55px"
                  // mt="-15px"
                  zIndex={2}
                >
                  <Flex id="price_quantity" justifyContent="space-between" mb="8px">
                    <Text fontSize="14px">Price</Text>
                    <Text fontSize="14px">Quantity</Text>
                  </Flex>

                  {loading ? (
                    <Flex p="7px 15px" justifyContent="center">
                      <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
                    </Flex>
                  ) : (
                    <Flex
                      id="price_input"
                      bg="#ececec"
                      borderRadius={24}
                      borderWidth={1}
                      justifyContent="space-between"
                    >
                      <Flex id="price" color="#020303" alignItems="center" ml="15px">
                        <Text fontWeight="bold" fontSize="20px" mr="7px">
                          {price?.usd && priceUsd(updated ? intentUsd?.amount / 100 : price?.usd / 100)} USD{' '}
                        </Text>
                        <Text fontSize="14px">
                          / {price?.micro_stacks && priceStx(updated ? intentStx?.amount : price?.micro_stacks)}{' '}
                        </Text>
                      </Flex>
                      <Flex>
                        <Input
                          borderRadius="5px 24px 24px 5px"
                          bg="#fff"
                          w="62px"
                          size="lg"
                          defaultValue={quantity}
                          type="number"
                          _placeholder={{ color: '#7f7f7f', fontSize: '14px' }}
                          _invalid={{ borderColor: '#e53e3e' }}
                          _focus={{ borderColor: '#000' }}
                          _disabled={{ color: 'gray.500' }}
                          color="#141416"
                          fontWeight="500"
                          onChange={(e) => debouncedSave(e.target.value)}
                        />
                      </Flex>
                    </Flex>
                  )}

                  <Divider my="20px" />

                  <Button variant="black" w="100%" mb="15px" size="lg" fontSize="16px" onClick={() => onPayUsd()}>
                    Pay USD By Credit Card
                  </Button>
                  <Button
                    variant="outline"
                    borderColor="#020303"
                    w="100%"
                    size="lg"
                    onClick={() => (updated ? onPayStxUpdated() : onPayStx())}
                  >
                    Pay with STX
                  </Button>
                </Flex>
              </Box>
            </Flex>
          </Flex>
        </Box>
      )}

      <Flex
        id="content"
        flex="1"
        borderRadius={8}
        borderWidth={1}
        borderColor={colorMode === 'dark' ? '#333' : null}
        p={{ base: '20px', md: '40px' }}
        mr={{ base: 0, md: '40px' }}
        flexDirection="column"
        boxShadow={colorMode === 'light' ? '0 0 16px 10px rgba(96, 109, 123, 0.05);border: solid 1px #ddd' : null}
        mb={{ base: 5, md: 0 }}
      >
        <Flex id="share" justifyContent="space-between" flex="1" mb="20px">
          <Button variant="outline" fontWeight="normal">
            <Text as="span" mr="5px" fontWeight="bold">
              {data?.non_fungible_tokens_count - data?.available_non_fungible_tokens_count}
            </Text>{' '}
            out of{' '}
            <Text as="span" mx="5px" fontWeight="bold">
              {data?.non_fungible_tokens_count}
            </Text>{' '}
            Minted
          </Button>
          <Popover>
            <PopoverTrigger>
              <IconButton size="lg" icon={<BsFillShareFill fontSize="20px" />} variant="ghost" />
            </PopoverTrigger>
            <PopoverContent zIndex={11} w="170px" py="7px">
              <PopoverArrow />

              <PopoverBody>
                <Flex justifyContent="center">
                  <Flex alignItems="center" cursor="pointer" p="3px" borderRadius={20} mr="20px">
                    <Icon as={FaFacebook} color="#0079ff" fontSize="35px" onClick={() => shareOnFacebook(url)} />
                  </Flex>
                  <Flex
                    alignItems="center"
                    cursor="pointer"
                    p="3px"
                    borderRadius={20}
                    onClick={() => shareOnTwitter(url)}
                  >
                    <Icon as={FaTwitter} color="#55acee" fontSize="35px" />
                  </Flex>
                </Flex>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </Flex>
        <Flex id="title" flexDirection="column" mb="30px">
          <Flex mb="5px" alignItems="center">
            <Flex alignItems="flex-start">
              <Image w="36px" src="/images/wrc-logo-card.png" alt="" mr="20px" />
            </Flex>
            <Link href="https://marketplace.heylayer.com/collection/455">
              <a>
                <Text color="#484949" fontSize="14px" fontWeight="500" mr="10px">
                  {data?.user?.username}
                </Text>
              </a>
            </Link>
            {data?.user?.is_verified && (
              <Image bottom="0px" right="2px" w="20px" h="20px" src="/images/icon-verified-icon.svg" alt="" />
            )}
          </Flex>
          <Text fontWeight="bold" fontSize="36px">
            {data?.name}
          </Text>
        </Flex>
        <Divider />
        <Flex id="gallery" flexDirection="column" mb="0px" py="40px">
          <Text fontWeight="extrabold" fontSize="20px" mb="20px">
            NFTs From This Collection
          </Text>
          {isLoading ? (
            <Flex p="7px 15px" justifyContent="center" h="400px" alignItems="center">
              <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
            </Flex>
          ) : (
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing="30px">
              {collection.map((c) => (
                <Flex key={c.id}>
                  {c?.file?.thumbnail_http_url ? (
                    <Image
                      cursor="pointer"
                      src={c?.file?.thumbnail_http_url || '/images/no_image.jpg'}
                      alt=""
                      borderRadius={8}
                      onClick={() => onOpenModal(c?.file?.thumbnail_http_url)}
                    />
                  ) : (
                    <Flex pos="relative">
                      <Image w="50px" pos="absolute" top="41%" left="40%" src="/images/wrc-logo-card.png" alt="" />
                      <Image objectFit="cover" src="/images/wrc_no_image.png" alt="" borderRadius={8} />
                    </Flex>
                  )}
                </Flex>
              ))}
            </SimpleGrid>
          )}

          {!isEmpty(meta) && <Pagination size="sm" pagination={meta} onPageChange={onPaginate} />}
        </Flex>
        <Divider />
        <Flex id="Transactions" flexDirection="column" mb="30px" p="40px 0 20px">
          <Text fontWeight="bold" fontSize="20px" mb="20px">
            Transactions
          </Text>
          <Flex id="table" flexDirection="column">
            <Flex
              id="header"
              bg={bgColor[colorMode]}
              // bg="#ddd"
              borderRadius="8px 8px 0 0 "
              borderWidth={colorMode === 'dark' ? 0 : 1}
              p="10px"
              fontWeight="bold"
              fontSize={{ base: '13px', md: '14px' }}
            >
              <Flex flex="2">Transaction</Flex>
              <Flex flex="1">Function</Flex>
              <Flex flex="1">Status</Flex>
              <Flex w="70px">Date</Flex>
            </Flex>
            {transactions.map((t, idx) => (
              <Flex
                key={idx}
                id="content"
                p="10px"
                // borderBottomWidth={1}
                borderBottomWidth={colorMode === 'dark' ? 0 : 1}
                fontSize="12px"
                color={colorMode === 'dark' ? 'gray.200' : '#020303'}
                bg={colorMode === 'dark' ? '#141414' : '#fcfcfc'}
                // bg="#fcfcfc"
              >
                <Flex flex="2" alignItems="center" textDecoration="underline">
                  <a
                    href={`https://explorer.stacks.co/txid/${t.transaction_id}?chain=${
                      process.env.NEXT_PUBLIC_ENV === 'production' ? 'mainnet' : 'testnet'
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {getStxAddress(t.transaction_id, 13)}
                    <Icon ml={2} as={FiExternalLink} fontSize="14px" color="#7a8087" />
                  </a>
                </Flex>
                <Flex flex="1">{t.contract_function}</Flex>
                <Flex flex="1">{truncate(t.status, 8)}</Flex>
                <Flex w="70px">{moment(t.burn_block_time).fromNow()}</Flex>
              </Flex>
            ))}
          </Flex>
        </Flex>
        <Divider />
        <Flex id="about_" flexDirection="column" mb="30px" p="40px 0 20px">
          <Text fontWeight="bold" fontSize="20px" mb="20px">
            About {data?.user.username}
          </Text>
          <Flex flex="1">
            <Flex alignItems="flex-start" w="80px" mr="30px" mt="7px">
              <Image w="36px" src="/images/wrc-logo-card.png" alt="" mr="20px" />
            </Flex>
            <Text fontWeight="normal" lineHeight="26px" color={colorMode === 'dark' ? null : '#020303'} fontSize="14px">
              {/* The Wave Riders Club by surfing.com is a collection of 5,000 Wave Rider NFTs – unique digital collectables
              anchored on the Bitcoin Blockchain via Stacks. */}
              {data?.user?.bio}
            </Text>
          </Flex>
        </Flex>
        <Divider />
        {/* <Flex id="about_artist" flexDirection="column" mb="30px" p="40px 0 20px">
          <Text fontWeight="bold" fontSize="20px" mb="20px">
            About the artist
          </Text>
          <Flex flex="1">
            <Flex alignItems="flex-start" w="80px" mr="30px" mt="7px">
              <Image w="36px" src="/images/wrc-logo-card.png" alt="" mr="20px" />
            </Flex>
            <Text fontWeight="normal" lineHeight="26px" color="#020303" fontSize="14px">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh
              finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie. Mauris malesuada nisi sit amet
              augue accumsan tincidunt. Maecenas tincidunt.
            </Text>
          </Flex>
        </Flex> */}
      </Flex>
      {device !== 'mobile' && (
        <Box w={{ base: '100%', md: '400px' }} m="0 auto" id="card">
          <Flex flexDirection="column" pos="relative" mb="20px" justifyContent="center" alignItems="center">
            <Flex flexDir="column" zIndex={10} justifyContent="center" alignItems="center">
              <Box borderRadius={8}>
                {randomNft ? (
                  <Box pos="relative" zIndex={1}>
                    <Image
                      objectFit="contain"
                      src={randomNft?.file?.thumbnail_http_url}
                      alt=""
                      borderRadius="8px 8px 0 0"
                    />
                  </Box>
                ) : (
                  <Box pos="relative" zIndex={1}>
                    <Image pos="absolute" top="41%" left="40%" src="/images/wrc-logo-card.png" alt="" />
                    <Image objectFit="contain" src="/images/card_example_2.png" alt="" />
                  </Box>
                )}

                <Flex
                  pos="relative"
                  flexDirection="column"
                  id="title"
                  bg={bgColor[colorMode]}
                  borderRadius={8}
                  borderWidth={colorMode === 'dark' ? 0 : 1}
                  p="10px 20px 30px"
                  mt="-55px"
                  // mt="-15px"
                  zIndex={2}
                >
                  <Flex id="price_quantity" justifyContent="space-between" mb="8px">
                    <Text fontSize="14px">Price</Text>
                    <Text fontSize="14px">Quantity</Text>
                  </Flex>

                  {loading ? (
                    <Flex p="7px 15px" justifyContent="center">
                      <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
                    </Flex>
                  ) : (
                    <Flex
                      id="price_input"
                      bg="#ececec"
                      borderRadius={24}
                      borderWidth={1}
                      justifyContent="space-between"
                    >
                      <Flex id="price" color="#020303" alignItems="center" ml="15px">
                        <Text fontWeight="bold" fontSize="20px" mr="7px">
                          {price?.usd && priceUsd(updated ? intentUsd?.amount / 100 : price?.usd / 100)} USD{' '}
                        </Text>
                        <Text fontSize="14px">
                          / {price?.micro_stacks && priceStx(updated ? intentStx?.amount : price?.micro_stacks)}{' '}
                        </Text>
                      </Flex>
                      <Flex>
                        <Input
                          borderRadius="5px 24px 24px 5px"
                          bg="#fff"
                          w="62px"
                          size="lg"
                          defaultValue={quantity}
                          type="number"
                          _placeholder={{ color: '#7f7f7f', fontSize: '14px' }}
                          _invalid={{ borderColor: '#e53e3e' }}
                          _focus={{ borderColor: '#000' }}
                          _disabled={{ color: 'gray.500' }}
                          color="#141416"
                          fontWeight="500"
                          onChange={(e) => debouncedSave(e.target.value)}
                        />
                      </Flex>
                    </Flex>
                  )}

                  <Divider my="20px" />

                  <Button variant="black" w="100%" mb="15px" size="lg" fontSize="16px" onClick={() => onPayUsd()}>
                    Pay USD By Credit Card
                  </Button>
                  <Button
                    variant="outline"
                    bg={colorMode === 'dark' ? '#fff' : null}
                    color={colorMode === 'dark' ? '#141414' : null}
                    borderColor="#020303"
                    w="100%"
                    size="lg"
                    onClick={() => (updated ? onPayStxUpdated() : onPayStx())}
                  >
                    Pay with STX
                  </Button>
                </Flex>
              </Box>
            </Flex>
          </Flex>
        </Box>
      )}
    </Flex>
  );
};

export default Step1;
